
import ViewModel from '@/models/ViewModel'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class TenancyTests extends ViewModel {}
